import React, { useState } from "react";
import { useAuth } from "../../auth/useAuth.js";
import { userApi } from "../../api/auctiongate.js";

export default function PriceList() {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pdfLink, setPdfLink] = useState(null);

  const load = async () => {
    setLoading(true);
    setErr(null);
    try {
      const r = await userApi.priceList({
        user_id: user?.id ?? "",
        master_email: user?.id ? "" : "master@auctiongate.io",
      });
      setData(r);
    } catch (e) {
      setErr(e?.message || "Failed");
    } finally {
      setLoading(false);
    }
  };

  const makePdf = async () => {
    setErr(null);
    const hash = data?.data?.hash;
    if (!hash) return setErr("Price list has no hash — refresh first.");
    try {
      const r = await userApi.pricePdf({ hash, sub_bidder_name: user?.name || "User" });
      setPdfLink(r?.data?.link || null);
    } catch (e) {
      setErr(e?.message || "Failed");
    }
  };

  return (
    <div className="card">
      <div className="card__title">
        Price list
        <span className="badge">/api/v1/price-list</span>
      </div>
      <div className="row">
        <button className="btn btn-ghost" onClick={load} disabled={loading}>
          {loading ? <span className="loader" /> : "Fetch"}
        </button>
        <button className="btn btn-primary" onClick={makePdf} disabled={!data?.data?.hash}>
          Make PDF
        </button>
        {pdfLink && (
          <a href={pdfLink} target="_blank" rel="noreferrer" className="btn btn-accent">
            Open PDF
          </a>
        )}
      </div>
      {err && <div className="login-error mt-2">{err}</div>}
      {data && (
        <pre style={{ fontSize: 11, marginTop: 10, maxHeight: 160, overflow: "auto", background: "var(--color-bg-card-elevated)", padding: 8, borderRadius: 6 }}>
          {JSON.stringify(data, null, 2).slice(0, 900)}
        </pre>
      )}
    </div>
  );
}
